var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center w-full h-full antialiased ",attrs:{"id":"app"}},[_c('LoadingComponent'),_c('div',{staticClass:"w-full overflow-x-hidden mobile:w-mobile md:w-md xl:w-xl"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }